<template>
  <hm-content title="促销列表">
    <div slot="header">
      <hm-step
        :steps="steps"
        :step="2"
        :disabledFirst="disabledFirst"
        disabledNext
      ></hm-step>
    </div>
    <div>
      <div class="selected-activity caption">
        <span class="mr10">促销内容</span>
        <span class="primary activity">({{ childTypeName }})</span>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-form-item label="促销名称：" prop="promotionName">
          <el-input
            type="text"
            v-model.trim="ruleForm.promotionName"
            clearable
            placeholder="请输入促销名称"
            size="small"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="促销时间："
          prop="validatorTime"
          ref="validatorTime"
        >
          <hm-date-select
            title="促销"
            :isShow="isShow"
            @swithRunningTimeType="swithRunningTimeType"
            ref="hmDateSelect"
            multipleTime
          ></hm-date-select>
        </el-form-item>
        <el-form-item label="参与门店：" prop="pasOutlets">
          <shop-picker
            :available-shops="storeOptions"
            :selected-shops.sync="selectedShops"
            @change="handleShopPickerChange"
          />
        </el-form-item>
        <el-form-item label="销售渠道：" prop="platformModels" v-if="false">
          <el-select
            clearable
            multiple
            size="small"
            value-key="platformId"
            v-model="ruleForm.platformModels"
            placeholder="请选择销售渠道"
          >
            <el-option
              :label="v.platformName"
              :value="v"
              v-for="(v, i) in salesChannels"
              :key="i"
            ></el-option>
          </el-select>
          <div class="form-item-tip">选择渠道后，商品信息会同步到对应渠道</div>
        </el-form-item>
        <el-form-item
          label="会员群组："
          prop="memberGroupList"
          v-if="childTypeName === '特价' || childTypeName === '满件数打折' || childTypeName === '满金额打折' || childTypeName === '组合价' "
        >
          <el-select
            clearable
            multiple
            filterable
            size="small"
            @change="getCheckedMemberGroup"
            v-model="ruleForm.memberGroupList"
            placeholder="请选择会员群组"
          >
            <el-option
              label="全部会员群组"
              :disabled="selectGroup"
              value="0"
            ></el-option>
            <el-option
              :label="v.groupAppellation"
              :value="v.groupId"
              :disabled="selectGroupAll"
              v-for="(v, i) in memberGroupList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Plus标签："
          prop="plusTag"
          v-if="childTypeName === '特价' "
        >
          <el-switch
            v-model="ruleForm.plusTag"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <el-form-item label="促销备注：" prop="newpromotionName">
          <el-input
            maxlength="240"
            v-model="ruleForm.introText"
            placeholder="请输入促销备注"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="促销标签：">
          <el-tag
            :key="tag"
            v-for="tag in ruleForm.pasLabels"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model.trim="inputValue"
            ref="saveTagInput"
            size="small"
            maxlength="10"
            clearable
            placeholder="请输入标签，在10个汉字以内"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ 新标签</el-button
          >
          <div class="form-item-tip" v-if="childTypeName === '特价'">
            标签将显示在商品详情页，默认显示第一条
          </div>
        </el-form-item>
        <el-form-item label="基础价：" prop="price" v-if="childTypeName !== '叠加赠送'">
          <el-radio-group v-model="ruleForm.assignPriceType">
            <el-radio label="promotion">会员价</el-radio>
            <!-- <el-radio label="retail">零售价</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否可参与用券" prop="couponUsable" v-if="childTypeName !== '叠加赠送'">
          <el-radio-group v-model="ruleForm.couponUsable">
            <el-radio label="yes">可参与用券</el-radio>
            <el-radio label="no">不可参与用券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="促销层级："
          prop="pasLevel"
          v-if="
            couponLevelList.length &&
              childTypeName !== '特价' &&
              childTypeName !== '组合价' &&
              childTypeName !== '满金额打折' &&
              childTypeName !== '件数-叠加' &&
              childTypeName !== '金额-叠加' &&
              childTypeName !== '金额-叠加(内测勿用)' &&
              childTypeName !== '件数-叠加(内测勿用)' &&
              childTypeName !== '满件数打折' &&
              childTypeName !== '满金额打折' &&
              childTypeName !== '叠加赠送'
          "
        >
          <el-select
            size="small"
            clearable
            placeholder="选择促销层级"
            v-model="ruleForm.pasLevel"
            class="mr10"
            filterable
          >
            <el-option
              v-for="(item, i) in couponLevelList"
              :key="i"
              :label="item.itemText"
              :value="item.itemValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="back"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="submitRuleForm('ruleForm')"
            >下一步</el-button
          >
        </div>
      </el-form>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import HmDateSelect from "@/components/HmDateSelect";
import { ShopPicker } from "@/components/shop-picker";
import { setCookie, getCookie, queryActivityCategory } from "../../utils/utils";
import { mapGetters } from "vuex";
export default {
  data() {
    const validatorFunc = (rule, val, callback) => {
      const {
        runningTimeType,
        ruleDateAndTime,
        ruleDate,
        dateType,
        dateValue,
        dateConfigRange,
        week,
        daysList
      } = this.$refs.hmDateSelect;
      // 选择全时段
      if (runningTimeType === "all") {
        if ((ruleDateAndTime && !ruleDateAndTime[0]) || !ruleDateAndTime) {
          return callback(new Error("请选择日期"));
        }
        callback();
        // 选择特定时段
      } else if (runningTimeType === "special") {
        if (dateConfigRange && !dateConfigRange.length) {
          return callback(new Error("请选择促销时间"));
        } else if ((ruleDate && !ruleDate.length) || !ruleDate) {
          return callback(new Error("请选择促销日期"));
        }
        if (dateType === "day") {
          if (!dateValue) {
            return callback(new Error("请输入促销天数"));
          } else callback();
        } else if (dateType === "week") {
          if (week && !week.length) {
            return callback(new Error("请选择促销周"));
          }
          callback();
        } else if (dateType === "month") {
          if (daysList && !daysList.length) {
            return callback(new Error("请选择促销天"));
          }
          callback();
        }
      }
    };
    return {
      isShow: true,
      id: "",
      disabledFirst: false,
      childTypeName: "",
      remark: "",
      parentId: "",
      selectOther: false,
      selectAll: false,
      selectGroup: false,
      selectGroupAll: false,
      selectedShops: [],
      steps: [
        {
          link: "SelectActivity",
          name: "选择促销类型"
        },
        {
          link: "CreatActivity",
          name: "创建促销"
        },
        {
          link: "GoodsManagement",
          name: "管理促销商品"
        },
        {
          link: "CreatGoodsRule",
          name: "创建规则"
        }
      ],
      subType: "",
      inputValue: "",
      inputVisible: false,
      ruleForm: {
        plusTag: "no",
        assignPriceType: "promotion",
        pasOutlets: [],
        memberGroupList: [],
        promotionName: "",
        introText: "",
        pasLabels: [],
        platformModels: [],
        pasLevel: "",
        couponUsable: "yes"
      },
      rules: {
        validatorTime: {
          required: true,
          validator: validatorFunc,
          trigger: "blur"
        },
        promotionName: [
          {
            required: true,
            min: 2,
            max: 30,
            message: "名称应大于2小于30个字",
            trigger: "blur"
          }
        ],
        pasOutlets: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        memberGroupList: {
          required: true,
          message: "请选择会员群组",
          trigger: "change"
        },
        platformModels: {
          required: true,
          message: "请选择销售渠道",
          trigger: "change"
        },
        pasLevel: {
          required: true,
          message: "请选择优惠券层级",
          trigger: "change"
        }
      },
      memberGroupList: [],
      couponLevelList: []
    };
  },
  computed: {
    ...mapGetters(["onlineMallstoreList", "salesChannels"]),
    // common/store_outlet_list 返回 {name, id}，转换为 ShopPicker 需要的 {shopName, shopId}
    storeOptions() {
      return (this.onlineMallstoreList || []).map(item => ({
        shopId: item.id,
        shopName: item.name
      }));
    }
  },
  created() {
    const { type, subType } = this.$route.query;
    this.subType = subType;
    this.disabledFirst = type === "edit";
    this.$store.dispatch("queryOnlineMallStoreList");
    this.$store.dispatch("querySalesChannels").then(res => {
      this.ruleForm.platformModels = [];
      this.ruleForm.platformModels.push(
        res.result.find(o => o.platformName === "微店")
      );
    });
    this.queryMemberGroupList();
  },
  mounted() {
    const STEP = getCookie({ key: "STEP" });
    console.log("STEP: ", STEP);
    this.parentId = STEP.step1.parentId;
    this.id = STEP.step1.id;
    this.childTypeName = queryActivityCategory({
      parentId: this.parentId,
      childId: STEP.step1.childId
    }).childTypeName;
    if (this.childTypeName == "特价") {
      this.ruleForm.pasLabels[0] = "特价";
    }
    if (
      this.parentId === "SpecialPrice" ||
      this.parentId === "CombinationPrice"
    ) {
      this.steps.splice(2, 1);
    }
    if(this.parentId==='SuperpositionGift'){
      this.steps.splice(2, 1);
      this.steps.push({
        link: "ConnectedActivities",
        name: "关联活动"
      })
    }
    if (this.disabledFirst) {
      this.requestSavedInfo(this.id, this.parentId);
    } else {
      // 数据回显
      this.cookieEcho(STEP);
    }
    this.getCheckedStore(this.ruleForm.pasOutlets);
    this.queryCouponLevelList();
    console.log("childTypeName:::", this.childTypeName);
  },
  beforeDestroy() {
    const data = getCookie({ key: "STEP" });
    data.step2 = this.getParams();
    setCookie({ key: "STEP", data });
  },
  watch: {
    // 监听门店列表变化，处理异步加载后的回显
    onlineMallstoreList: {
      handler(newList) {
        if (
          newList &&
          newList.length > 0 &&
          this.ruleForm.pasOutlets &&
          this.ruleForm.pasOutlets.length
        ) {
          this.setSelectedShops();
        }
      },
      immediate: true
    }
  },
  methods: {
    async queryCouponLevelList() {
      let params = {
        dictCode: "pas_level"
      };
      const { result } = await this.$store.dispatch("queryPasList", params);
      if (result) {
        const { sysDictItem } = result;

        this.couponLevelList = sysDictItem;
      }
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "0") > -1;
      this.selectAll = storeList.findIndex(o => o === "0") > -1;
    },
    // 门店选择变化
    handleShopPickerChange(shops) {
      this.ruleForm.pasOutlets = shops.map(s => s.shopId || s.id);
    },
    // 根据 pasOutlets 回显已选门店
    setSelectedShops() {
      const shopIds = this.ruleForm.pasOutlets || [];
      const availableShops = this.storeOptions;
      if (shopIds.length === 1 && shopIds[0] === "0") {
        // 兼容历史数据：全部门店
        this.selectedShops = [...(availableShops || [])];
      } else if (shopIds.length > 0) {
        this.selectedShops = shopIds.map(shopId => {
          const shop = availableShops.find(
            s => String(s.shopId || s.id) === String(shopId)
          );
          return shop || { shopId: shopId, shopName: shopId };
        });
      } else {
        this.selectedShops = [];
      }
    },
    getCheckedMemberGroup(groupList) {
      this.selectGroup = groupList.findIndex(o => o !== "0") > -1;
      this.selectGroupAll = groupList.findIndex(o => o === "0") > -1;
    },
    cookieEcho(STEP) {
      console.log("STEP: ", STEP);
      if (STEP.step2) {
        for (let key in STEP.step2) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = STEP.step2[key];
          }
        }

        this.$refs.hmDateSelect.runningTimeType = STEP.step2.runningTimeType;
        if (this.$refs.hmDateSelect.runningTimeType === "all") {
          this.$refs.hmDateSelect.ruleDateAndTime = [
            STEP.step2.promotionStartTime,
            STEP.step2.promotionEndTime
          ];
        } else if (this.$refs.hmDateSelect.runningTimeType === "special") {
          this.$refs.hmDateSelect.dateConfigRange = STEP.step2.dateConfigRange;
          this.$refs.hmDateSelect.dateType = STEP.step2.dateType;
          this.$refs.hmDateSelect.ruleDate = [
            STEP.step2.promotionStartDate,
            STEP.step2.promotionEndDate
          ];
          if (STEP.step2.dateType === "day") {
            this.$refs.hmDateSelect.dateValue = STEP.step2.dateValue;
          } else if (STEP.step2.dateType === "week") {
            this.$refs.hmDateSelect.week = STEP.step2.dateValue;
          } else if (STEP.step2.dateType === "month") {
            this.$refs.hmDateSelect.daysList = STEP.step2.dateValue;
          }
        }
        this.selectAll = STEP.step2.pasOutlets.findIndex(o => o === "0") > -1;
        this.selectGroupAll =
          STEP.step2.memberGroupList.findIndex(o => o === "0") > -1;
        this.setSelectedShops();
      }
    },
    requestSavedInfo(id, parentId) {
      switch (parentId) {
        // 满额减金额，减件数
        case "FullReduction":
          this.$store
            .dispatch("queryFullReductionDetails", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "fullReductionRule");
            });
          break;
        // 满件数送商品，满金额送商品
        case "FullDelivery":
          this.$store
            .dispatch("queryFullDelivertDetails", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "fullDeliveryGoods");
            });
          break;
        // 满件数叠加送商品，满金额叠加送商品
        case "FullDeliveryOverlay":
          this.$store
            .dispatch("queryFullDelivertDetailsOverlay", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "fullDeliveryGoods");
            });
          break;
        // 满件数加价换购
        case "IncreasePurchase":
          this.$store
            .dispatch("queryIncreasePurchaseDetails", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "increasePurchaseRules");
            });
          break;
        // 满件数打折
        case "FullDiscount":
          this.$store
            .dispatch("queryFullDiscountDetails", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "fullDiscountRule");
            });
          break;
        // 特价
        case "SpecialPrice":
          this.$store
            .dispatch("querySpecialRuleDetails", {
              id,
              parentId
            })
            .then(res => {
              res.result.listHot.forEach(v => {
                v.attrType = v.selectType;
              });
              this.resToCookie(res.result, "listHot");
            });
          break;
        // 组合价
        case "CombinationPrice":
          this.$store
            .dispatch("queryCombinationDetails", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "combinationPriceRules");
            });
          break;
        // 叠加赠送
        case "SuperpositionGift":
          this.$store
            .dispatch("querySuperpositionGift", {
              id,
              parentId
            })
            .then(res => {
              this.resToCookie(res.result, "connectedActiviesList");
            });
          break;
        default:
          break;
      }
    },
    resToCookie(result, ruleList) {
      console.log("ruleList: ", ruleList);
      const data = getCookie({ key: "STEP" });
      const pasOutlets = result.pasOutlets.map(v => v.outletId);
      const memberGroupList = result.memberGroupList.map(v => v.groupId);
      const pasLabels = result.pasLabels.map(v => v.labelKey);
      this.selectOther = pasOutlets.findIndex(o => o !== "0") > -1;
      this.selectGroup = memberGroupList.findIndex(o => o !== "0") > -1;
      let dateValue;

      if (result.dateConfigInfo) {
        if (result.dateConfigInfo.dateType === "day") {
          dateValue = result.dateConfigInfo.dateValue;
        } else {
          dateValue = result.dateConfigInfo.dateValues;
        }
      }
      let step4 = result[ruleList] || [];
      let step5 = [];
      const discountMode =
        result[ruleList] && result[ruleList][0]
          ? result[ruleList][0].discountMode
          : "";
      if (discountMode === "fullPriceDiscount") {
        step4 = {
          discountMode: result[ruleList][0].discountMode,
          list: result[ruleList]
        };
      } else if (discountMode === "floorPriceDiscount") {
        step4 = {
          discountMode: result[ruleList][0].discountMode,
          purchasesAmount: result[ruleList][0].purchasesAmount,
          discountRatio: result[ruleList][0].discountRatio
        };
      }
      if (ruleList === "fullDeliveryGoods") {
        if (this.parentId === "FullDeliveryOverlay") {
          step4 = {
            fullDeliveryGoods: result[ruleList],
            fullDeliveryOverlayRuleModel: result.fullDeliveryOverlayRuleModel
          };
        } else {
          step4 = {
            fullDeliveryGoods: result[ruleList],
            fullDeliveryRule: result.fullDeliveryRule
          };
        }
      }
      if (ruleList === "combinationPriceRules") {
        step4 = {
          combinationPriceRules: result.combinationPriceRules,
          combinationPriceGoods: result.combinationPriceGoods
        };
      }
      if (ruleList === "listHot") {
        step4.forEach(v => {
          v.shopPrices = v.shopPrice;
        });
      }
      if (ruleList === "connectedActiviesList"){
        console.log("叠加赠送第四步");
        step4 = {
          pasSuperpositionGiftRuleLimitModel: result.pasSuperpositionGiftRuleLimitModel,
          pasSuperpositionGiftRuleGoodsModelList: result.pasSuperpositionGiftRuleGoodsModelList,
        }
        step5 = {
          pasSuperpositionGiftRelationPromotionModels: result.pasSuperpositionGiftRelationPromotionModels,
        }
      }
      const tags = result.pasLabels;
      const storeListRes = [];
      this.onlineMallstoreList.forEach(v => {
        result.pasOutlets.forEach(item => {
          if (String(v.id) === String(item.outletId)) {
            storeListRes.push(v);
          }
        });
      });
      const groupListRes = [];
      this.memberGroupList.forEach(v => {
        result.memberGroupList.forEach(item => {
          if (String(v.groupId) === String(item.groupId)) {
            groupListRes.push(v);
          }
        });
      });
      Object.assign(data, {
        step2: {
          pasLevel: result.basicConfigInfo.pasLevel + "",
          assignPriceType: result.basicConfigInfo.assignPriceType,
          plusTag: result.basicConfigInfo.plusTag,
          storeListRes,
          groupListRes,
          tags,
          pasOutlets,
          memberGroupList,
          promotionName: result.basicConfigInfo.promotionName,
          introText: result.basicConfigInfo.introText,
          pasLabels,
          platformModels: result.platformModels,
          runningTimeType: result.basicConfigInfo.runningTimeType,
          promotionStartTime: result.pasCalendars
            ? result.pasCalendars.promotionStartTime
            : "",
          promotionEndTime: result.pasCalendars
            ? result.pasCalendars.promotionEndTime
            : "",
          promotionStartDate: result.dateConfigInfo
            ? result.dateConfigInfo.promotionStartDate
            : "",
          promotionEndDate: result.dateConfigInfo
            ? result.dateConfigInfo.promotionEndDate
            : "",
          dateValue,
          dateType: result.dateConfigInfo ? result.dateConfigInfo.dateType : "",
          dateConfigRange: result.dateConfigRange || [],
          couponUsable: result.basicConfigInfo.couponUsable
        },
        step3: result.pasGoods,
        step4,
        step5
      });
      setCookie({ key: "STEP", data });

      this.cookieEcho(data);
    },
    swithRunningTimeType() {
      this.$refs.validatorTime.clearValidate();
    },
    sortTime(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return (
          new Date(new Date().toLocaleDateString() + " " + value1).getTime() -
          new Date(new Date().toLocaleDateString() + " " + value2).getTime()
        );
      };
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = getCookie({ key: "STEP" });
          data.step2 = this.getParams();
          if (!data.step2.storeListRes || !data.step2.storeListRes.length) {
            const storeListRes = [];
            this.onlineMallstoreList.forEach(v => {
              this.ruleForm.pasOutlets.forEach(item => {
                if (String(v.id) === String(item)) {
                  storeListRes.push(v);
                }
              });
            });
            data.step2.storeListRes = storeListRes;
          }
          if (!data.step2.groupListRes || !data.step2.groupListRes.length) {
            const groupListRes = [];
            this.memberGroupList.forEach(v => {
              this.ruleForm.memberGroupList.forEach(item => {
                if (String(v.groupId) === String(item)) {
                  groupListRes.push(v);
                }
              });
            });
            data.step2.groupListRes = groupListRes;
          }
          setCookie({ key: "STEP", data });
          // 跳转路由
          if (
            this.parentId === "SpecialPrice" ||
            this.parentId === "CombinationPrice" ||
            this.parentId === "SuperpositionGift"
          ) {
            const route = {
              name: "CreatGoodsRule"
            };
            if (this.disabledFirst) {
              if (!this.subType) {
                Object.assign(route, {
                  query: {
                    type: "edit"
                  }
                });
              } else {
                Object.assign(route, {
                  query: {
                    type: "edit",
                    subType: "copy"
                  }
                });
              }
            }
            this.$router.push(route);
          } else {
            const route = {
              name: "GoodsManagement"
            };
            if (this.disabledFirst) {
              if (!this.subType) {
                Object.assign(route, {
                  query: {
                    type: "edit"
                  }
                });
              } else {
                Object.assign(route, {
                  query: {
                    type: "edit",
                    subType: "copy"
                  }
                });
              }
            }
            this.$router.push(route);
          }
        } else {
          return false;
        }
      });
    },
    getParams() {
      // 转化需要的参数
      const storeListFormat = [];
      const groupListFormat = [];
      const tags = [];
      this.ruleForm.pasOutlets.forEach(v => {
        storeListFormat.push({ outletId: v });
      });
      this.ruleForm.memberGroupList.forEach(v => {
        groupListFormat.push({ groupId: v });
      });
      this.ruleForm.pasLabels.forEach(v => {
        tags.push({ labelKey: v });
      });
      const {
        runningTimeType,
        ruleDateAndTime,
        ruleDate,
        dateType,
        dateValue,
        dateConfigRange,
        week,
        daysList
      } = this.$refs.hmDateSelect;
      const data = getCookie({ key: "STEP" });
      let step2;
      if (data.step2) {
        step2 = Object.assign(data.step2, this.ruleForm, {
          runningTimeType,
          storeListFormat,
          groupListFormat,
          tags
        });
      } else {
        step2 = Object.assign(this.ruleForm, {
          runningTimeType,
          storeListFormat,
          groupListFormat,
          tags
        });
      }
      if (runningTimeType === "all") {
        // 选择全时段
        step2.promotionStartTime = ruleDateAndTime.length
          ? ruleDateAndTime[0]
          : "";
        step2.promotionEndTime = ruleDateAndTime.length
          ? ruleDateAndTime[1]
          : "";
      } else if (runningTimeType === "special") {
        // 选择特定时段
        step2.dateConfigRange = dateConfigRange.sort(
          this.sortTime("promotionStartTime")
        );
        step2.promotionStartDate = ruleDate[0];
        step2.promotionEndDate = ruleDate[1];
        step2.dateType = dateType;
        if (dateType === "day") {
          step2.dateValue = dateValue;
        } else if (dateType === "week") {
          step2.dateValue = week;
        } else if (dateType === "month") {
          step2.dateValue = daysList;
        }
      }
      console.log("step2: ", step2);
      return step2;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleClose(tag) {
      this.ruleForm.pasLabels.splice(this.ruleForm.pasLabels.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.pasLabels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    back() {
      this.$router.back(-1);
    },
    setSteps() {
      this.steps= [
        {
          link: "SelectActivity",
          name: "选择促销类型"
        },
        {
          link: "CreatActivity",
          name: "创建促销"
        },
        {
          link: "GoodsManagement",
          name: "创建规则"
        },
        {
          link: "CreatGoodsRule",
          name: "关联活动"
        }
      ]
    },
  },
  components: {
    HmStep,
    HmDateSelect,
    ShopPicker
  }
};
</script>

<style scoped lang="scss">
.activity-list {
  text-align: center;
  li {
    width: 200px;
    box-sizing: border-box;
    padding: 20px;
    transition: all linear 0.2s;
    user-select: none;
    .line {
      margin: 0 5px;
    }
    .category-name:hover {
      .category {
        color: #e60e6d;
      }
    }
  }
  li:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px;
  }
  .img-wrapper {
    img {
      width: 70px;
    }
  }

  .activity-name {
    color: #000;
    margin: 10px 0;
  }

  .activity-category {
    .category-name {
      font-size: 12px;
    }
  }
}
</style>
